<div class="current-region-container">
    <div class="current-region-title">
      <mat-icon class="region-icon">public</mat-icon>
      <p>Current Region: </p>
    </div>
    <app-select
      [options]="admin?.regions"
      [optionAccessor]="regionName"
      [value]="currentRegion"
      [control]="userRegionFormControl"
      (selectionChange)="changeCurrentRegion()"
    ></app-select>
  </div>
